import React, { createContext, useContext, useMemo, useState } from 'react';

interface LogoClickContextType {
  logoClickHandler: ((e: React.MouseEvent<HTMLAnchorElement>) => void) | null;
  setLogoClickHandler: (
    handler: ((e: React.MouseEvent<HTMLAnchorElement>) => void) | null
  ) => void;
}

const LogoClickContext = createContext<LogoClickContextType | undefined>(
  undefined
);

export function LogoClickProvider({ children }: { children: React.ReactNode }) {
  const [logoClickHandler, setLogoClickHandler] = useState<
    ((e: React.MouseEvent<HTMLAnchorElement>) => void) | null
  >(null);

  return (
    <LogoClickContext.Provider
      value={useMemo(
        () => ({ logoClickHandler, setLogoClickHandler }),
        [logoClickHandler, setLogoClickHandler]
      )}
    >
      {children}
    </LogoClickContext.Provider>
  );
}

export const useLogoClick = () => {
  const context = useContext(LogoClickContext);
  if (context === undefined) {
    throw new Error('useLogoClick must be used within a LogoClickProvider');
  }
  return context;
};
